import { FC, useMemo } from 'react'
import { Redirect } from 'react-router-dom'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { useMutableRef } from 'hooks/useMutableRef'


export const NavigateToHandler: FC = () => {
  const navigateTo = useStoreSelector((state) => state.app.navigation.navigateToUrl)

  const navigateToRef = useMutableRef<typeof navigateTo | null>(null)
  useMemo(() => {
    if (navigateTo === null) {
      return
    }

    navigateToRef.current = navigateTo
  }, [navigateTo, navigateToRef])

  const { to, push } = useMemo(() => {
    if (typeof navigateTo === 'string') {
      return {
        to: navigateTo,
        push: true,
      }
    } else if (!!navigateTo) {
      const { push: nextPush = true, ...restTo } = navigateTo
      return {
        to: restTo,
        push: nextPush,
      }
    }

    return {
      to: null,
      push: true,
    }
  }, [navigateTo])

  if (!navigateToRef.current || !navigateTo || to === null) {
    return null
  }

  return (
    <Redirect to={ to } push={ push } />
  )

}
